import { LandingChile, LandingPeruTD } from "../../components";
import { useAuthContext } from "../../context/auth";

export const LandingTD = () => {
  const { pais } = useAuthContext();

  if (pais === "Perú") {
    return <LandingPeruTD />;
  }

  if (pais === "Chile") {
    return <LandingChile />;
  }

  return <div>País no reconocido</div>;
};
